import { create_with_times } from '@bighealth/api/SleepWindow/v1';

import { createWithTimes } from 'lib/api';
import * as reporter from 'lib/reporter';

async function submitSleepWindow({
  fromTime,
  toTime,
  sceneSetGraphId,
}: {
  fromTime: Date;
  toTime: Date;
  sceneSetGraphId: number;
}): Promise<[create_with_times.Response | null, Error | null]> {
  try {
    const response = await createWithTimes({
      fromTime,
      toTime,
      sceneSetGraphId,
    });
    if (response.status_code !== 200) {
      reporter.log('Error in the creation of the sleep window');
      return [null, new Error('Error in the creation of the sleep window')];
    }
    return [response, null];
  } catch (e) {
    reporter.log(e?.message, e);
    return [null, e];
  }
}

export { submitSleepWindow };
